import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../services/contexts/AuthContext';
import SystemAdminSidebar from './components/SystemAdminSidebar';
import SystemAdminDashboard from './pages/SystemAdminDashboard';
import TenantManagement from './pages/TenantManagement';
import QuestionManagement from './pages/QuestionManagement';
import GlobalUserManagement from './pages/GlobalUserManagement';
import GlobalPatientOverview from './pages/GlobalPatientOverview';
import SystemConfiguration from './pages/SystemConfiguration';
import SecurityCompliance from './pages/SecurityCompliance';
import SystemAnalytics from './pages/SystemAnalytics';
import SystemMaintenance from './pages/SystemMaintenance';
import { LogOut } from 'lucide-react';

const SystemAdminApp = () => {
  const { user, logout } = useAuth();
  const [activeView, setActiveView] = useState('dashboard');

  const handleLogout = () => {
    logout();
  };

  // Get user display name
  const getUserDisplayName = () => {
    if (user?.name) {
      return user.name;
    } else if (user?.email) {
      return user.email.split('@')[0]; // Use email prefix as name
    }
    return 'System Administrator';
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* System Admin Sidebar */}
      <SystemAdminSidebar activeView={activeView} setActiveView={setActiveView} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation Bar */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between px-6 py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">System Administration</h1>
              <p className="text-sm text-gray-600">Complete system oversight and management</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{getUserDisplayName()}</p>
                <p className="text-xs text-gray-500">
                  {user?.email || 'System Administrator'}
                </p>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-6">
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<SystemAdminDashboard />} />
            <Route path="tenants" element={<TenantManagement />} />
            <Route path="questions" element={<QuestionManagement />} />
            <Route path="users" element={<GlobalUserManagement />} />
            <Route path="patients" element={<GlobalPatientOverview />} />
            <Route path="configuration" element={<SystemConfiguration />} />
            <Route path="security" element={<SecurityCompliance />} />
            <Route path="analytics" element={<SystemAnalytics />} />
            <Route path="maintenance" element={<SystemMaintenance />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default SystemAdminApp;